import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";
import styled from "styled-components";

const { carbon } = colorsPalettes;

export const StyledLeaderWrapper = styled(FlexColumn)`
    gap: 6px;
    align-items: flex-start;
    justify-content: center;
    width: 17%;

    @media (min-width: 1439px) {
        width: 14.5%;
    }
    @media (min-width: 1919px) {
        width: 14%;
    }
`;

export const StyledDisabledLeaderDomain = styled.div`
    width: 97px;
    height: 14px;
    background: linear-gradient(90deg, #f3f5f8 0%, #edf1f5 100%);
`;

export const StyledDisabledLeaderIcon = styled.div`
    position: relative;
    width: 16px;
    height: 16px;
    border: 1px solid #d6dbe1;
    border-radius: 3px;
    background: ${carbon[0]};

    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        width: 8px;
        height: 8px;
        border-radius: 2px;
        background: #d6dbe1;
    }
`;

export const StyledLeaderTitle = styled.div`
    ${setFontVariant("listItem3", carbon[400])}
`;

export const StyledLeaderValue = styled.div`
    ${setFontVariant("subtitle2", carbon[400])}
`;

export const StyledDomain = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100px;

    @media (min-width: 1919px) {
        width: 140px;
    }
`;

export const StyledLeaderWebsiteWrapper = styled(FlexRow)`
    height: 24px;
    align-items: center;
    gap: 8px;

    .ItemIcon {
        width: 17px;
        height: 17px;
    }

    ${setFontVariant("input2", carbon[400])}
`;
